import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const pageSearch = {
  'archiveTime': {
    title: '归档日期',
    type: 'date',
    equation: all,
    defaultOption: "GE",
    defaultVal: '2024-11-26',
    valueFormat: 'yyyy-MM-dd'
  },
  'saleCenter': {
    describe: true, // 描述 _text 添加属性
    suffix: 'TextView',
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    defaultOption: "NE", //默认选择条件
    defaultVal: ['','0005000172'], //默认值
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'wantCode': {
    title: '发货单号',
    type: 'input',
    equation: cusname
  },
  'customerCode': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'brandBq': {
    describe: true,
    suffix: 'TextView',
    title: '存货分类',
    type: 'select',
    dictionary: 'A0019',
    width: 200
  },
  'productCode': {
    title: '产品',
    type: 'dialog',
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    },
    equation: all,
    width: 180
  },
  'createdDated': {
    title: '申请时间',
    type: 'date',
    equation: all,
    width: 150,
    valueFormat: 'yyyy-MM-dd'
  },
}
export default {
  'wantCode': {
    slot: true,
    title: '发货单号',
  },
  'customerCode': {
    title: '订单客户编号',
  },
  'customerName': {
    title: '订单客户名称',
    width: 200,
    type: 'input',
  },
  'planType': {
    describe: true,
    suffix: 'TextView',
    title: '要货类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'saleCenterTextView': {
    title: '营销战区', // 字段名称
    width: 180
  },
  'province': {
    title: '省',
    type: 'select',
    describe: true,
    suffix: 'TextView',
    dictionary: 'region',
    equation: city,
    width: 120
  },
  'receiveCityName': {
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city',
    width: 120
  },
  'kaStoreFullname': {
    title: '卖场全称'
  },
  'shuntDealer': {
    title: '分流经销商',
    width: 200,
    type: 'input',
  },
  'invPropertyTextView': {
    // describe: true,
    title: '发票性质',
    // type: 'select',
    equation: city,
    width: 120
    // dictionary: 'inv_property'
  },
  'createdTime': {
    title: '申请日期'
  },
  'createdDated': {
    title: '申请时间',
    width: 150,
  },
  'archiveDate': {
    title: '归档日期'
  },
  'archiveTime': {
    title: '归档时间',
    width: 150
  },
  'brandBqTextView': {
    title: '存货分类',
    width: 200
  },
  'productCode': {
    title: '产品',
    width: 180
  },
  'productDesc': {
    title: '产品名称',
    width: 300
  },
  'receiveAddress': {
    title: '收货地址',
    width: 200
  },
  'deliveryqty': {
    title: '申请数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'isShunt': {
    title: '是否分流',
    type: 'select',
    formatter: ({ cellValue }) => cellValue === '1' ? '是' : '否',
    dictionary: 'B0099'
  },
  'handleNode': {
    title: '节点',
    type: 'input'
  },
  'shipStatus': {
    describe: true,
    suffix: 'TextView',
    title: '安吉状态',
    type: 'select',
    equation: city,
    dictionary: 'B0101'
  },
  'ggtg': {
    describe: true,
    suffix: 'TextView',
    title: '渠道类型',
    type: 'select',
    dictionary: 'goods_channel_type'
  },
  'channelsType': {
    describe: true,
    suffix: 'TextView',
    title: '要货渠道类型',
    type: 'select',
    dictionary: 'A0054'
  },
  'netValuePre': {
    title: '价税合计（折扣前）',
    type: 'input',
    width: 130
  },
  'netValueDis': {
    title: '价税合计（折扣后）',
    type: 'input'
  },
  'remark': {
    title: '备注',
    type: 'input',
    width: 200
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/shipmentInfoForms.js